// extracted by mini-css-extract-plugin
module.exports = {"list":"BrandsPage_list__ex-kG","listContainer":"BrandsPage_listContainer__-t_Y-","spanLoading":"BrandsPage_spanLoading__38l5U","rotateLoading":"BrandsPage_rotateLoading__3K9Fp"};